import { HTMLAttributes } from "react";

type SVGPropsT = {
  width?: string;
};

export const FileSVG: React.FC<HTMLAttributes<HTMLOrSVGElement> & SVGPropsT> = ({ width = "20", ...props }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6666 1.66667H4.99992C4.55789 1.66667 4.13397 1.84227 3.82141 2.15483C3.50885 2.46739 3.33325 2.89131 3.33325 3.33334V16.6667C3.33325 17.1087 3.50885 17.5326 3.82141 17.8452C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8452C16.491 17.5326 16.6666 17.1087 16.6666 16.6667V6.66667L11.6666 1.66667Z"
        stroke="#00B856"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 1.66667V6.66667H16.6667"
        stroke="#00B856"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3334 10.8333H6.66675"
        stroke="#00B856"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3334 14.1667H6.66675"
        stroke="#00B856"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33341 7.5H7.50008H6.66675"
        stroke="#00B856"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
